import { rankOf } from "../data/levels.js";
import { GROUPME, LIBRARY } from "../data/library.js";
import { CULTURE } from "../data/culture.js";
import { TRIBE } from "../data/tribe.js";
import { CALENDAR } from "../data/calendar.js";
import { OPS } from "../data/ops.js";

// One flat index over every destination in the hub. Entries carry either `p`
// (an in-app view) or `url` (an external link). Locked entries stay in the
// index but are filtered out of results.
export function buildIndex(userRank) {
  const out = [];
  const page = (icon, name, desc, p, minLevel) =>
    out.push({
      icon,
      name,
      desc,
      p,
      locked: minLevel ? userRank < rankOf(minLevel) : false,
      minLevel,
    });

  page("🧬", "Culture Codes", "Vision, mission, pillars, and all 14 codes.", "culture");
  page("🧭", "myTRiBE+ Journey", "SERVE · PRAY · GIVE — classes and checkpoints.", "tribe");
  page("🗓️", "myTRiBE Calendar", "Everything coming up in the room.", "calendar");
  page("🙏", "Prayer & Testimony Wall", "Post a request or share what God did.", "wall");
  page("🎒", "Back to School · Aug 2", "Two services launch. The full plan.", "launch");
  page("🙌", "Join the Dream Team", "Meet the teams and raise your hand.", "dreamteam");
  page("🎵", "CLLXTV Music", "Song of the day and worship sets.", "worship");
  page("🚀", "Onboarding", "Your first-week page — five steps.", "onboard");
  page("📈", "LEADERSHiP+", "Build your leadership lid.", "leadershipplus", "leader");
  page("🤝", "Request a meeting", "Grab time with a pastor or leader.", "meet", "leader");
  page("📜", "SOPs & Playbooks", "Your team's checklists and how-tos.", "ops");
  page("🐞", "Report an issue", "Something broken? Tell the team.", "report");
  page("🪪", "My Dashboard", "Your inbox, updates, and replies in one place.", "dashboard");
  page("🗂️", "Org Chart", "SATX Campus reporting lines.", "org", "director");

  for (const g of GROUPME) {
    out.push({
      icon: g.icon,
      name: g.name + " (GroupMe)",
      desc: g.desc,
      linkId: g.id,
      locked: userRank < rankOf(g.minLevel),
    });
  }
  for (const f of LIBRARY) {
    out.push({
      icon: f.icon,
      name: f.name,
      desc: f.desc,
      linkId: f.id,
      locked: userRank < rankOf(f.minLevel),
    });
  }
  for (const c of CULTURE.codes) {
    out.push({ icon: "🧬", name: "Code " + c.n + ": " + c.name, desc: c.line, p: "culture" });
  }
  for (const step of TRIBE.path) {
    if (step.type === "course") {
      out.push({ icon: "🧭", name: step.name, desc: step.desc, p: "tribe" });
    }
  }
  for (const e of CALENDAR.singles) {
    out.push({ icon: e.emoji, name: e.name, desc: e.d + " · " + e.time, p: "calendar" });
  }
  for (const b of OPS.breakouts) {
    out.push({
      icon: b.icon,
      name: b.name,
      desc: b.desc,
      linkId: b.url, // ops breakouts store the id in `url` — see data/ops.js
      locked: userRank < rankOf("director"),
    });
  }

  return out;
}
